import React from 'react';
import { CollageImage, ClickableItem } from '../CollageImage';
import './CollageSection.css';

export interface CollageConfig {
    id: string;
    baseImage: string;
    baseImageLowRes?: string;
    clickableItems: ClickableItem[];
    alt?: string;
    caption?: string;
}

export interface CollageSectionProps {
    collages: CollageConfig[];
    className?: string;
}

export const CollageSection: React.FC<CollageSectionProps> = ({ 
    collages,
    className = ''
}) => {
    return (
        <div className={`collage-section ${className}`}>
            {collages.map((collage) => (
                <div key={collage.id} className="collage-item">
                    <CollageImage
                        baseImage={collage.baseImage}
                        baseImageLowRes={collage.baseImageLowRes}
                        clickableItems={collage.clickableItems}
                        alt={collage.alt}
                    />
                    {collage.caption && (
                        <p className="collage-caption">{collage.caption}</p>
                    )}
                </div>
            ))}
        </div>
    );
};
